import { render, staticRenderFns } from "./EnergyTab.vue?vue&type=template&id=656be950&scoped=true"
import script from "./EnergyTab.vue?vue&type=script&lang=ts"
export * from "./EnergyTab.vue?vue&type=script&lang=ts"
import style0 from "./EnergyTab.vue?vue&type=style&index=0&id=656be950&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656be950",
  null
  
)

export default component.exports